import { styled } from '@linaria/react';

import WavesSvg from '../../../../../public/assets/Waves.svg';
// eslint-disable-next-line
export const WSvg = styled(WavesSvg)`
	position: absolute;
	top: 0;
	left: -10%;
	right: 0;
	bottom: 0;
	display: block;
	overflow: hidden;
	z-index: -2;
	width: 110%;
	height: inherit;
	height: -moz-available;
	height: -webkit-fill-available;
	color: var(--bot-color-main);
	pointer-events: none;
	-webkit-mask-image: linear-gradient(
		to left,
		transparent 20%,
		rgba(0, 0, 0, 1)
	);

	@media screen and (max-width: 768px) {
		left: -35%;
		right: initial;
		width: 175%;
		-webkit-mask-image: none;
	}

	@keyframes depthAnimation {
		0%,
		30% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	path {
		opacity: 1;
		transform-origin: center center;
		animation-timing-function: cubic-bezier(0.36, 0.11, 0.89, 0.32);
		animation-duration: 3s;
		animation-iteration-count: infinite;
		animation-name: depthAnimation;
		animation-delay: calc(var(--index) * 0.15s);

		@media screen and (min-width: 769px) {
			transform: scale(1.6);
		}
	}

	${Array.from(
		{ length: 12 },
		(_, i) => `.w${i + 1} { --index: ${12 - i + 1}; }`
	).join('\n')}
`;
